import { EnvType } from "../services";
import ApiClient from "../api-client";
import IShareApiClient, { IpLocationServiceApiResponse } from "../Share/share-api-client";
import ShareApiClient from "../Share/share-api-client";
import { GetSharesResponse } from "../Types/get-shares-response";
import { GetShareByKeyResponse } from "../Types/get-share-by-key-response";
import { GetShareInfosResponse } from "../Types/get-share-infos-response";
import { CreateShareRequest } from "../Types/create-share-request";
import { GenericResponseStd } from "../Types/generic-response-std";
import { CreateShareMultipleRequest } from "../Types/create-share-multiple-request";
import { UpdateShareRequest } from "../Types/update-share-request";
import { AddClipsRequest } from "../Types/add-clips-request";
import { CreateClipsResponse } from "../Types/create-clips-response";
import { ImportClipsRequest } from "../Types/import-clips-request";
import { CreateAssetShareRequest } from "../Types/create-asset-share-request";
import { ListShareAssetByIdResponse } from "../Types/list-share-asset-by-id-response";
import { GetAssetShareResponse } from "../Types/get-asset-share-response";
import { ShareFormValues } from "../../../Components/Modals/ModalCreateShare/modal-create-share";
import { UpdateShareReceipientsRequest } from "../Types/update-share-receipients-request";
import { GetShareMetadataResponse } from "../Types/get-share-metadata-response";
import { GetShareResponse } from "../Types/get-share-response";
export default class ShareService {
  shareApiClient: IShareApiClient;

  constructor(envType: EnvType) {
    this.shareApiClient = new ShareApiClient(new ApiClient(envType), envType);
  }
  async GetAllShares(pageNb: number, pageSize: number): Promise<GetSharesResponse> {
    return await this.shareApiClient.GetAllShares(pageNb, pageSize);
  }
  async GetShareByKey(key: string): Promise<GetShareByKeyResponse> {
    return await this.shareApiClient.GetShareByKey(key);
  }
  async GetShareInfos(): Promise<GetShareInfosResponse> {
    return await this.shareApiClient.GetShareInfos();
  }
  async CreateShare(formValues: ShareFormValues, overlayTextOverride?: string): Promise<GenericResponseStd> {
    const request: CreateShareRequest = new CreateShareRequest({
      objectId: formValues.stepTwo.feature?.id ?? formValues.stepOne.objectId,
      audioAuthorizedLanguagesCodes: formValues.localizationSection.audioFinal,
      subtitleAuthorizedLanguagesCodes: formValues.localizationSection.subtitleFinal,
      episodeNb: formValues.stepTwo.epSelected.length !== 0 ? formValues.stepTwo.epSelected : null,
      shareName: formValues.settingsSection.shareName,
      comment: formValues.settingsSection.comment,
      maxClipsNumber: formValues.securitySection.maxClips,
      maxIPs: formValues.securitySection.maxIps,
      maxClipsDuration: formValues.securitySection.maxClipDuration,
      watermarkTemplate: formValues.securitySection.watermarkTemplate,
      watermarkText: overlayTextOverride ? overlayTextOverride : formValues.securitySection.watermarkContent,
      recipientEmails: formValues.recipientsSection.emails,
      burnTimecode: formValues.securitySection.printTimeCode,
      type: formValues.securitySection.securityMode,
      maxViews: formValues.settingsSection.maxViews,
      maxDays: formValues.settingsSection.expirationDate ? formValues.settingsSection.expirationDate : null,
      oneSharePerEmail: formValues.onTheFlyEmailOverlay,
    });

    return await this.shareApiClient.CreateShare(request);
  }
  async CreateMultipleShare(formValues: ShareFormValues, overlayTextOverride?: string): Promise<GenericResponseStd> {
    let objectIds: number[] = [];
    formValues.assetIds.forEach((id) => {
      objectIds.push(id);
    });
    const request: CreateShareMultipleRequest = new CreateShareMultipleRequest({
      objectIds: objectIds,
      shareName: formValues.settingsSection.shareName,
      comment: formValues.settingsSection.comment,
      maxClipsNumber: formValues.securitySection.maxClips,
      maxIPs: formValues.securitySection.maxIps,
      maxClipsDuration: formValues.securitySection.maxClipDuration,
      watermarkTemplate: formValues.securitySection.watermarkTemplate,
      watermarkText: overlayTextOverride ? overlayTextOverride : formValues.securitySection.watermarkContent,
      recipientEmails: formValues.recipientsSection.emails,
      burnTimecode: formValues.securitySection.printTimeCode,
      maxDays: formValues.settingsSection.expirationDate ? +formValues.settingsSection.expirationDate : null,
      maxViews: formValues.settingsSection.maxViews,
      type: formValues.securitySection.securityMode,
      oneSharePerEmail: formValues.onTheFlyEmailOverlay,
    });
    return await this.shareApiClient.CreateMultipleShare(request);
  }
  async DeleteShareById(shareId: number): Promise<GenericResponseStd> {
    return await this.shareApiClient.DeleteShareById(shareId);
  }
  async UpdateShare(request: UpdateShareRequest): Promise<GetShareResponse> {
    return await this.shareApiClient.UpdateShare(request);
  }
  async UpdateShareRecipients(request: UpdateShareReceipientsRequest): Promise<GetShareResponse> {
    return await this.shareApiClient.UpdateShareRecipients(request);
  }
  async AddClips(request: AddClipsRequest): Promise<CreateClipsResponse> {
    return await this.shareApiClient.AddClips(request);
  }
  async NotifyClips(request: AddClipsRequest): Promise<GenericResponseStd> {
    return await this.shareApiClient.NotifyClips(request);
  }
  async DeleteClip(key: string, clipId: number): Promise<GenericResponseStd> {
    return await this.shareApiClient.DeleteClip(key, clipId);
  }
  async ImportClips(request: ImportClipsRequest): Promise<GenericResponseStd> {
    return await this.shareApiClient.ImportClips(request);
  }
  async CreateObjectShare(request: CreateAssetShareRequest): Promise<GenericResponseStd> {
    return await this.shareApiClient.CreateObjectShare(request);
  }
  async ListShareObjectByObjectId(objectId: number): Promise<ListShareAssetByIdResponse> {
    return await this.shareApiClient.ListShareObjectByObjectId(objectId);
  }
  async GetObjectShare(key: string): Promise<GetAssetShareResponse> {
    return await this.shareApiClient.GetObjectShare(key);
  }
  async GetAllSharesByObjectId(objectId: number): Promise<GetSharesResponse> {
    return await this.shareApiClient.GetAllSharesByObjectId(objectId);
  }
  async GetShareMetadataById(shareId: number): Promise<GetShareMetadataResponse> {
    return await this.shareApiClient.GetShareMetadataById(shareId);
  }
  async _GetIpLocation(ip: string): Promise<IpLocationServiceApiResponse> {
    return await this.shareApiClient._GetIpLocation(ip);
  }

  //------Utils------
  GetServiceUrl(): string {
    return this.shareApiClient.GetApiUrl();
  }
}
